export default __webpack_public_path__ + "static/media/refresh-white.eef5280f.svg";